import React, { useState } from 'react';
import './Login.css';
import logo from '../Assets/sdspc-logo.png';
import sideimage from '../Assets/loginSideImage.jpg';

import { useNavigate } from 'react-router-dom';
import axios from "axios";

const Login = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle login logic here
    console.log('Login attempted with:', { username, password });

    axios.post(`${API_BASE_URL}login.php`,
      {
        email: username,
        password: password
      }
    )
      .then((response) => {
        if (response.data.head.code === 200) {
          // let responseData = JSON.parse(response.data)
          // setUserList(response.data.body);
          // setFilteredOrders(response.data.body);
          // window.location.reload();
          localStorage.setItem('user_id', JSON.stringify(response.data.body.user_id));
          localStorage.setItem('user_name', JSON.stringify(response.data.body.name));
          localStorage.setItem('desig_name', JSON.stringify(response.data.body.desig_name));
          localStorage.setItem('email', JSON.stringify(response.data.body.email));
          localStorage.setItem('leave_status', JSON.stringify(response.data.body.leave_status));
          localStorage.setItem('od_status', JSON.stringify(response.data.body.od_status));
          navigate('/home');
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setErrorMsg(response.data.head.msg);
          // setUserList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setErrorMsg(error);
        // setUserList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-main-container">
        {/* Logo in top left corner (desktop/tablet) */}
        <div className="logo-section">
          <img className="logo-main" src={logo} alt="SDS Polytechnic College Logo" />
        </div>

        {/* Main Content with Side Image and Login Card */}
        <div className="login-content-container">
          {/* Side Image */}
          <div className="side-image-container">
            <img className="side-image" src={sideimage} alt="Campus View" />
          </div>

          {/* Login Card */}
          <div className="login-card-container">
            <div className="login-card">
              {/* Logo inside card for mobile (hidden on larger screens) */}
              <img src={logo} alt="SDS Logo" className="logo-inside" />
              {errorMsg && <p className="error-style">{errorMsg}</p>}
              <h2 className="welcome-text">Welcome to </h2>
              <h2 className="welcome-text">SDS Polytechnic College</h2>

              {/* Left aligned instruction above username (always present) */}
              <h6 className="login-instruction-left">Log in Your Account</h6>

              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group floating">
                  <input
                    type="mobile"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder=" "
                    required
                    className="floating-input"
                    aria-label="username"
                  />
                  <label htmlFor="username" className="floating-label">Mobile Number</label>
                </div>

                <div className="form-group floating">
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder=" "
                    required
                    className="floating-input"
                    aria-label="password"
                  />
                  <label htmlFor="password" className="floating-label">Password</label>
                </div>

                <button type="submit" className="login-button">Log In</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
